import React from "react";
import { CheckIcon, StethoscopeIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
import { MOCKUP_URL } from "../data/offer";
import { toolkitHighlights } from "../data/content";
export function Hero() {
  return <section className="relative bg-brand-950 text-white" data-id="element-170" data-mp="4n1lcrjx0csi">
      <div className="bg-gold-400 px-4 py-2.5 text-center text-xs font-extrabold uppercase tracking-wide text-brand-950 sm:text-sm" data-id="element-171" data-mp="1297cg4ndx19u">
        Special digital offer · Today only $27
      </div>

      <div className="mx-auto max-w-6xl px-5 pb-14 pt-10 md:px-8 md:pb-20 md:pt-16" data-id="element-172" data-mp="sbb1pdyd08c9">
        <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_1fr] lg:gap-14" data-id="element-173" data-mp="sd4aozwg34nf">
          <div data-id="element-174" data-mp="neawt6d8xbmq">
            <p className="inline-flex items-center gap-2 text-sm font-bold text-gold-300" data-id="element-175" data-mp="3d1ildbzsjgoh">
              <StethoscopeIcon className="h-4 w-4" aria-hidden="true" data-id="element-176" data-mp="3cz5uuafyvxzt" />
              For gynecologists, family physicians & women's health professionals
            </p>
            <h1 className="mt-4 text-[2rem] font-extrabold leading-[1.1] tracking-tight sm:text-5xl lg:text-[3.4rem]" data-id="element-177" data-mp="3j9265qny7uwl">
              Turn a complex perimenopause case into a{" "}
              <span className="text-gold-400" data-id="element-178" data-mp="399bavmrkdbvg">structured clinical assessment</span> and documented management plan
            </h1>
            <p className="mt-5 text-lg leading-relaxed text-brand-100 md:text-xl" data-id="element-179" data-mp="3e7l780p0yiin">
              Using one 5-Step Decision Roadmap™. Stop piecing together scattered symptoms, menstrual changes,
              laboratory results, and competing clinical considerations.
            </p>
            <p className="mt-4 text-sm font-semibold text-brand-200" data-id="element-180" data-mp="2ql6dqy5ewp5m">
              Perimenopause Clinical Decision Roadmap™ · By Dr. Karito
            </p>
          </div>

          <div className="relative" data-id="element-181" data-mp="2hix03zeukfo0">
            <img src={MOCKUP_URL} alt="Perimenopause Clinical Decision Roadmap: 6 clinical volumes and 5 bonuses" className="mx-auto w-full max-w-[560px] drop-shadow-[0_30px_50px_rgba(0,0,0,0.45)]" data-id="element-182" data-mp="2hjyot6osd0o7" />
          </div>
        </div>

        <div className="mt-12 grid gap-10 lg:grid-cols-[1.05fr_1fr] lg:gap-14" data-id="element-183" data-mp="najihr3gojgl">
          <div data-id="element-184" data-mp="ibgiwm6935g0">
            <h2 className="text-xl font-extrabold" data-id="element-185" data-mp="id03uq2uq4o4">Inside your toolkit</h2>
            <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-186" data-mp="ddwx91783qe1">
              {toolkitHighlights.map(item => <li key={item} className="flex items-start gap-3 text-base font-medium text-brand-50" data-id="element-187" data-mp="1azumdhg3ytyy">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gold-400 text-brand-950" data-id="element-188" data-mp="16346au4azydj">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-189" data-mp="114svoh66pju9" />
                  </span>
                  {item}
                </li>)}
            </ul>
            <p className="mt-6 text-base leading-relaxed text-brand-200" data-id="element-190" data-mp="3lu9x916uryb8">
              No lengthy lectures. No overwhelming theory. Just practical clinical decision-support tools you can
              adapt to your next consultation.
            </p>
          </div>

          <div className="rounded-3xl bg-white p-6 text-ink shadow-2xl md:p-8" data-id="element-191" data-mp="21bxyn68yqubv">
            <p className="text-center text-sm font-bold uppercase tracking-wide text-brand-700" data-id="element-192" data-mp="269hci51r153a">
              Get the complete clinical roadmap
            </p>
            <div className="mt-2 flex items-end justify-center gap-3" data-id="element-193" data-mp="2b2sk48edxpw9">
              <span className="pb-2 text-xl font-bold text-muted line-through" data-id="element-194" data-mp="2fzaov89pto8l">$194</span>
              <span className="text-6xl font-extrabold tracking-tight text-brand-800" data-id="element-195" data-mp="2kxkjnhrj2mto">$27</span>
            </div>
            <p className="mt-1 text-center text-xs font-medium text-muted" data-id="element-196" data-mp="2p10ec8k1ed3q">
              Price shown in USD · Currency conversion is automatic at checkout
            </p>
            <div className="mt-6" data-id="element-197" data-mp="un95hb9j7x9c">
              <CTAButton id="hero-cta" label="Yes! I want to structure my next perimenopause case" pulse className="md:w-full" data-id="element-198" data-mp="uoak1pprb1vt" />
            </div>
            <ul className="mt-5 grid grid-cols-2 gap-x-3 gap-y-2 text-sm font-semibold text-ink" data-id="element-199" data-mp="4auq6v9zx7pw">
              {["Instant digital access", "One-time payment of $27", "Downloadable resources", "7-day guarantee"].map(t => <li key={t} className="flex items-center gap-1.5" data-id="element-200" data-mp="e8setjvrp6j1">
                    <CheckIcon className="h-4 w-4 shrink-0 text-emerald-600" strokeWidth={3} aria-hidden="true" data-id="element-201" data-mp="9bifnciktgi0" />
                    {t}
                  </li>)}
            </ul>
            <div className="mt-7 border-t border-brand-100 pt-6" data-id="element-202" data-mp="3csihvwpsqwxu">
              <Countdown data-id="element-203" data-mp="3rftw66dd4v1n" />
            </div>
            <div className="mt-6" data-id="element-204" data-mp="3rhmzpcsoiz5f">
              <ScarcityBar data-id="element-205" data-mp="3mpdg0ei5qvbl" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}